import { useState } from "react";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { MaskLines, Overline, Reveal } from "./Reveal";

const steps = [
  ["Discovery", "We map goals, data and constraints, then pick the use cases with the clearest return.", "bg-amber"],
  ["Architecture & data", "Data audits, pipelines and a system design that scales with security built in.", "bg-emerald"],
  ["Build & tune", "Rapid prototypes, model selection, fine-tuning and evaluation against real tasks.", "bg-violet"],
  ["Deploy & evolve", "Production rollout, monitoring and continuous improvement after go-live.", "bg-coral"],
];

export const Process = () => {
  const [active, setActive] = useState(0);
  return (
    <section id="process" data-testid="process-section" className="bg-ink py-24 text-[#FBF9F5] md:py-36">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-5 sm:px-6 lg:grid-cols-12 lg:px-8">
        <div className="lg:col-span-5">
          <p className="mb-6 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-white/75"><span className="h-2 w-2 rounded-full bg-amber" />02 — Process</p>
          <h2 className="font-display text-5xl leading-[1] tracking-tight sm:text-6xl lg:text-7xl">
            <MaskLines inView lines={["From idea", <em className="text-amber">to impact,</em>, "in four moves."]} />
          </h2>
          <Reveal delay={0.2} className="mt-10 overflow-hidden rounded-[24px]">
            <img src="/img/team.jpg" alt="Team collaborating" className="aspect-[4/3] w-full object-cover" />
          </Reveal>
        </div>
        <div className="lg:col-span-7 lg:pt-24">
          {steps.map(([title, text, dot], i) => (
            <Reveal key={title} delay={i * 0.08}>
              <button
                data-testid={`process-step-${i + 1}`}
                onClick={() => setActive(i)}
                onMouseEnter={() => setActive(i)}
                className="group w-full border-t border-white/15 py-7 text-left last:border-b"
              >
                <div className="flex items-center gap-5 sm:gap-8">
                  <span className="font-mono text-sm text-white/70">0{i + 1}</span>
                  <span className={`font-display text-3xl transition-colors sm:text-5xl ${active === i ? "text-white" : "text-white/55"}`}>{title}</span>
                  <span className={`ml-auto flex h-10 w-10 shrink-0 items-center justify-center rounded-full transition-all duration-500 ${active === i ? `${dot} rotate-45 text-ink` : "border border-white/25"}`}>
                    <Plus className="h-5 w-5" />
                  </span>
                </div>
                <motion.div initial={false} animate={{ height: active === i ? "auto" : 0, opacity: active === i ? 1 : 0 }} transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }} className="overflow-hidden">
                  <p className="max-w-lg pl-10 pt-4 text-base leading-relaxed text-white/80 sm:pl-14">{text}</p>
                </motion.div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
